import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_FooterComp = _resolveComponent("FooterComp")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_NavBar),
    _createVNode(_component_RouterView),
    _createVNode(_component_FooterComp)
  ], 64))
}